import { useState } from 'react'

import { useProduct } from '../../index.js'
import { useI18n } from '../../../../shared/i18n/useI18n.js'

import { CollapsiblePane } from './CollapsiblePane.jsx'
import { ModeLearnModal } from './ModeLearnModal.jsx'

import styles from './ModeDetailsPane.module.scss'

/**
 * ModeDetailsPane — short description of the currently active PlanView mode.
 *
 * Reads the active mode from ProductContext and renders:
 *  - CollapsiblePane wrapper (title = active mode name)
 *  - A short localised description (product.mode_{mode}_desc)
 *  - A "Dowiedz się więcej" link that opens ModeLearnModal
 *
 * If no description key exists for the active mode (empty or missing i18n value),
 * the pane returns null.
 *
 * The modal is kept in ModeLearnModal — a standalone component that can be
 * opened from ModeControllerPane, tooltips, or any other context.
 */
export function ModeDetailsPane() {
  const { t } = useI18n()
  const { modes } = useProduct()
  const activeMode = modes?.activeMode ?? null

  const [isModalOpen, setIsModalOpen] = useState(false)

  if (!activeMode) return null

  const descKey  = `product.mode_${activeMode}_desc`
  const descText = t(descKey)

  // If the i18n module returns the raw key (missing translation), hide pane
  if (!descText || descText === descKey) return null

  return (
    <>
      <CollapsiblePane
        title={t(`product.mode_${activeMode}`)}
        collapseAriaLabel={t('product.pane_mode_details_collapse_aria')}
        expandAriaLabel={t('product.pane_mode_details_expand_aria')}
      >
        <div className={styles.modeDetailsPane}>
          <p className={styles.description}>{descText}</p>
          {/* <button
            className={styles.learnMoreBtn}
            onClick={() => setIsModalOpen(true)}
          >
            {t('product.mode_details_learn_more')}
          </button> */}
        </div>
      </CollapsiblePane>

      {/* <ModeLearnModal
        mode={activeMode}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      /> */}
    </>
  )
}
